var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione04Img01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 404.61 311.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M314.57,94.44s-7.86-.26-10.08-8.09c-2.21-7.83,4.92-9.66,7.62-13.05,2.7-3.39,2.7-12,16.22-13.57,13.52-1.57,18.92,7.05,17.94,12.52,0,0,55.05,1.82,57.99,12.27,2.95,10.44-14.01,10.96-14.01,10.96,0,0,15.48,5.48,13.52,13.57-1.97,8.09-18.92,5.48-18.92,5.48,0,0,10.57,8.61,7.37,19.05-3.19,10.44-21.87,5.74-36.61-3.65-14.74-9.4-41.04-35.49-41.04-35.49",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.97,310.77c1.25-21.21,2.68-51.09,1.7-62.72-1.59-18.87-11.4-39.71-11.4-39.71l-70.02,14.08-24.02,88.35h103.73Z",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.85,308.53h-.02c-.2-.01-.34-.19-.33-.4l.11-1.91c1.34-23.45,2.6-45.6.89-68.51-.53-2.5-.91-5.1-1.28-7.62-.84-5.77-1.7-11.74-4.5-16.77-.1-.18-.04-.41.12-.51.17-.11.38-.04.48.13,2.87,5.16,3.74,11.2,4.59,17.04.36,2.51.74,5.11,1.27,7.6,0,.02,0,.04,0,.05,1.72,22.97.45,45.16-.89,68.64l-.11,1.91c-.01.2-.17.35-.35.35",
    style: {
      fill: "#e3ebf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.39,251.52s-.03,0-.05,0c-5.77-.83-10.41-5.25-13.41-12.79-2.25-5.65-2.8-11.14-2.81-11.2-.02-.21.12-.39.31-.41.2-.02.37.13.39.33.02.21,2.25,21.41,15.61,23.32.19.03.33.22.3.42-.02.19-.17.32-.35.32",
    style: {
      fill: "#e3ebf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39,136.78s27.04-18.64,44.1-22.02c17.06-3.38,36.73,10.14,38.46,29.17,1.73,19.04-8.1,37.47-13.59,47.6-5.49,10.14,0,15.36,0,20.27s-15.91,12.28-44.25,15.97c-28.34,3.69-34.12.31-35.28-1.23-1.16-1.54,9.1-42.82,9.1-42.82l-9.12,2.57,10.58-49.51Z",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.83,229.79c-5.64,0-9.04-.54-11.07-1.18-.19-.06-.3-.27-.24-.46.05-.2.25-.31.44-.25,3.81,1.18,12.47,2.05,32.11-.51,23.74-3.09,37.21-8.45,41.9-12.44.15-.13.37-.11.49.06.12.16.1.4-.05.52-4.76,4.05-18.36,9.49-42.26,12.6-9.35,1.22-16.25,1.66-21.32,1.66",
    style: {
      fill: "#e3ebf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21,178.39c-.16,0-.3-.11-.34-.28-2.76-11.19,6.54-24.44,9.6-28.8.4-.56.77-1.1.82-1.21.08-.18.28-.28.45-.21.17.07.27.27.21.45-.06.18-.27.49-.92,1.42-3.01,4.29-12.16,17.32-9.49,28.16.05.2-.06.4-.25.46-.03,0-.06.01-.09.01",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.8,97.46s9.56,17.34,11.03,19.06c0,0-16.19,8.75-23.84,17.81,0,0,2.5-7.66,4.86-11.72l-5-17.5,12.95-7.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.92,120.51c-.15,0-.29-.11-.34-.27l-4.26-14.89c-.05-.17.02-.35.17-.44l13.17-7.79c.17-.1.38-.04.47.14.06.12,6.42,11.64,9.6,16.89.11.18.06.41-.11.52-.17.11-.38.06-.49-.11-2.89-4.78-8.39-14.71-9.44-16.6l-12.62,7.46,4.17,14.6c.06.2-.05.41-.24.47-.03,0-.07.02-.1.02",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,86.11s-1.07,8.97,3.21,16.41c4.28,7.45,10.15,8.81,15.24,7.6,7.9-1.9,10.16-7.9,10.42-11.55,0,0,5.62.91,6.95-5.17s-5.21-8.21-8.55-3.19c0,0-1.74,2.28-3.74-2.13-2.01-4.41-5.21-9.88-6.82-9.58-1.6.3-4.41,5.32-8.02,6.84-3.61,1.52-8.69.76-8.69.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.57,86.52c-.14,1.76-.48,9.4,3.19,15.8,4.82,8.4,11.38,8.26,14.86,7.43,7-1.68,9.83-6.89,10.15-11.21,0-.11.06-.2.13-.27.08-.06.18-.09.27-.08.21.04,5.31.78,6.55-4.88.62-2.83-.59-4.53-1.93-5.17-1.63-.78-4.2-.4-5.99,2.28-.04.05-.66.86-1.64.74-.97-.12-1.88-1.1-2.71-2.92-2.45-5.37-5.34-9.57-6.44-9.37-.59.11-1.54,1.17-2.55,2.29-1.47,1.62-3.29,3.64-5.4,4.53-3.13,1.32-7.26.97-8.5.83M326.49,110.87c-3.72,0-8.54-1.56-12.33-8.16-4.29-7.47-3.27-16.56-3.26-16.65.01-.1.06-.19.14-.25.08-.06.17-.09.26-.07.05,0,5.03.73,8.51-.74,1.97-.83,3.73-2.78,5.15-4.35,1.19-1.32,2.13-2.35,2.94-2.51,2.46-.47,6.72,8.73,7.2,9.78.89,1.95,1.66,2.43,2.15,2.49.58.08.99-.42,1-.44,2-3,4.95-3.41,6.84-2.51,1.6.76,3.05,2.74,2.33,6.02-1.19,5.41-5.66,5.56-6.98,5.49-.47,4.51-3.49,9.79-10.66,11.51-.92.22-2.04.39-3.28.39",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.95,95.39c-.17,0-.32-.13-.35-.32-.15-1.17.24-2.4,1.03-3.23.79-.83,1.97-1.23,3.06-1.04.19.04.32.23.29.43-.03.2-.21.34-.4.31-.88-.15-1.82.17-2.46.84-.64.66-.95,1.66-.83,2.6.03.21-.11.39-.3.42-.01,0-.03,0-.05,0",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.56,136.45l-6.81,11.63-10.95-7.23c-21.6-14.26-49.98-7.22-63.41,15.71-13.42,22.93-6.8,53.08,14.8,67.33l87.81,52.37,56.77-88.19c13.42-22.93,6.8-53.08-14.8-67.33-21.59-14.25-49.99-7.22-63.41,15.71",
    style: {
      fill: "#e3ebf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.05,170.61c-.15,0-.3-.11-.34-.28-.05-.2.06-.41-2.18.4l75.97-22.08c2.61-.91,2.81-.79,2.86-.6.05.2-.06.41-.25.46l-75.97,22.08s-.06.01-.09.01",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.46,122.09s-6-2.41-14.92,4.48c-8.92,6.88-37.61,47.77-37.61,47.77l-45.72,27.89,9.97,27.11s58.61-18.33,70.53-25.31c11.92-6.97,34.53-34.86,39.15-42.87l-21.4-39.08Z",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.18,229.71c-.14,0-.27-.09-.33-.24l-9.97-27.12c-.06-.17,0-.37.15-.46l45.66-27.85c1.69-2.4,28.88-41.02,37.65-47.79,8.97-6.93,15-4.62,15.25-4.52.18.07.27.29.21.48-.07.2-.27.29-.45.22-.06-.02-5.95-2.24-14.58,4.43-8.77,6.78-37.25,47.29-37.54,47.7-.03.04-.07.07-.11.1l-45.46,27.73,9.74,26.5c4.62-1.45,58.85-18.57,70.15-25.18,11.83-6.92,34.27-34.5,39.03-42.74.1-.18.32-.23.49-.12.17.11.22.34.11.51-4.78,8.28-27.36,36.03-39.28,43-11.81,6.91-70.01,25.15-70.6,25.34-.03,0-.07.02-.1.02",
    style: {
      fill: "#e3ebf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.87,202.16s-17.02,4.85-23.55,5.08c-6.53.23-5.01,6.71.44,7.17,0,0-6.6,4.23-11.38,7.23-4.79,3-3.85,7.1.5,6.4,0,0-3.67,2.24-2.57,4.57,1.24,2.63,5.99.55,5.99.55,0,0-.86,2.95,2.48,3.84,2.48.66,7.54-.77,7.54-.77,0,0-3.41,5.82,5.79,3.51,5.09-1.27,24.77-10.41,24.77-10.41l-10.01-27.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.33,235.86c.11,0,.22.05.28.15.08.13.09.29.01.42,0,.02-1,1.75-.34,2.72.44.65,1.8,1.22,5.74.23,4.65-1.17,21.86-9.07,24.4-10.24l-9.77-26.52c-2.39.67-17.23,4.79-23.32,5.01-2.41.09-3.93,1.1-3.96,2.66-.03,1.63,1.64,3.53,4.41,3.76.15.01.28.13.32.29.03.16-.03.32-.16.41-.06.04-6.65,4.26-11.38,7.23-2.54,1.6-3.31,3.42-2.94,4.52.33,1,1.56,1.45,3.21,1.19.16-.03.33.07.39.25.05.17-.01.36-.16.45-.03.02-3.36,2.09-2.43,4.08,1.08,2.3,5.5.39,5.54.37.13-.06.27-.03.37.07.1.1.14.25.1.39,0,0-.29,1.04.21,1.97.36.67,1.03,1.14,2.01,1.4,2.37.63,7.32-.75,7.37-.76.03,0,.06-.01.09-.01M241.5,240.66c-1.38,0-2.3-.36-2.79-1.08-.6-.88-.33-2.05-.04-2.8-1.52.37-4.99,1.1-6.98.58-1.18-.31-2.01-.91-2.46-1.76-.36-.68-.41-1.37-.37-1.87-1.37.49-4.76,1.4-5.87-.95-.82-1.75.59-3.38,1.67-4.29-1.36-.08-2.36-.7-2.71-1.75-.43-1.29.16-3.48,3.25-5.42,3.73-2.34,8.6-5.46,10.54-6.69-2.61-.6-4.1-2.58-4.07-4.37.03-1.56,1.27-3.27,4.64-3.39,6.41-.23,23.3-5.02,23.47-5.07.17-.05.35.05.42.22l10.01,27.17c.07.19-.01.4-.19.48-.8.37-19.77,9.16-24.83,10.43-1.47.37-2.7.55-3.69.55",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.68,214.45c-.14,0-.27-.09-.33-.23-.08-.19.01-.41.19-.49,4.54-1.96,8.97-4.32,13.17-7.01.17-.11.38-.05.48.13.1.18.05.41-.12.51-4.23,2.71-8.69,5.09-13.27,7.06-.04.02-.09.03-.13.03",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.19,236.31c-.14,0-.28-.1-.33-.25-.07-.2.03-.41.21-.48l1-.38c2.17-.82,4.05-1.54,6.16-2.6.18-.09.39,0,.47.18.08.19,0,.41-.17.5-2.15,1.08-4.04,1.8-6.23,2.64l-1,.38s-.08.02-.12.02",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.08,310.8c-4.05-51.64-24.41-106.3-32.11-116.42-10.04-13.19-85.3-3.01-85.3-3.01l-17.53,119.43h134.95Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.14,311.18s-.04,0-.05,0c-.19-.03-.33-.22-.29-.43l17.53-119.43c.02-.17.15-.29.3-.31,3.08-.42,75.57-10.06,85.62,3.15,7.84,10.31,28.14,65.07,32.19,116.62.01.21-.13.39-.32.41-.2.02-.37-.14-.38-.34-4.04-51.42-24.23-105.96-32.03-116.22-9.51-12.5-79.82-3.55-84.72-2.91l-17.49,119.15c-.03.19-.17.32-.35.32",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.98 132.12 30.55 205.74 70.18 205.58 78.81 205.61 9.98 132.12",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.77,177.91l13.25-31.33c-7.05-8.18-14.1-16.35-21.15-24.52-5.21-9.95-9.19-18-11.7-23.16-9.87-20.27-13-28.68-22.1-33.91-4.9-2.82-9.93-3.79-10.94-3.98-7.31-1.35-13.35-.04-16.7.98l-53.62,20.16C.58,89.38-6.23,114.57,6.47,131.52l40.33,55.97c7.85,10.55,22.6,19.38,35.21,18.13l48.57-6.03,19.65-21.68h-7.46Z",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23,164.44h-.02l-27.72-1.73c-.19-.01-.34-.19-.33-.4,0-.21.18-.37.37-.35l27.72,1.72c.19.01.34.19.33.4,0,.2-.17.35-.35.35",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,160.43c-.11,0-.22-.06-.29-.16l-33.67-52.25c-.11-.17-.07-.4.09-.52.16-.12.38-.07.49.1l33.67,52.25c.11.17.07.4-.09.52-.06.04-.13.06-.2.06",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.01,160.43c-.13,0-.25-.08-.32-.21l-28.04-59.71c-.09-.19-.02-.41.16-.5.17-.09.39-.02.47.17l28.04,59.71c.09.19.02.41-.16.5-.05.03-.11.04-.16.04",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.72,172.86c.68-.24,28.01-17.17,28.92-23.94.91-6.77-4.1-7.98-8.65-6.29-4.55,1.69-45.09,25.14-45.09,25.14l24.82,5.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.93,167.61l23.75,4.86c1.94-1,27.75-17.18,28.61-23.6.34-2.51-.13-4.34-1.39-5.44-1.49-1.3-4.03-1.46-6.8-.44-4.11,1.52-38.27,21.22-44.17,24.62M175.72,173.23s-.04,0-.07,0l-24.82-5.08c-.15-.03-.26-.15-.28-.31-.02-.16.05-.31.18-.38,1.66-.96,40.61-23.49,45.14-25.17,3-1.11,5.79-.9,7.48.56,1.01.88,2.11,2.65,1.64,6.13-.4,2.94-5.34,7.88-14.7,14.67-6.99,5.08-14.04,9.42-14.46,9.57-.04.01-.07.02-.11.02",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.65,175.52c.68-.24,28.01-17.17,28.92-23.94.91-6.77-4.1-7.98-8.65-6.29-4.55,1.69-45.09,25.14-45.09,25.14l24.82,5.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.86,170.27l23.75,4.86c1.98-1.02,27.78-17.38,28.61-23.6.34-2.51-.13-4.34-1.39-5.44-1.49-1.3-4.03-1.46-6.8-.44-4.11,1.53-38.27,21.22-44.17,24.62M186.65,175.89s-.05,0-.07,0l-24.82-5.08c-.15-.03-.26-.15-.28-.31-.02-.16.05-.31.18-.38,1.66-.96,40.61-23.49,45.14-25.17,3-1.11,5.8-.9,7.48.56,1.01.88,2.11,2.65,1.64,6.13-.39,2.94-5.34,7.88-14.7,14.67-6.99,5.08-14.04,9.42-14.46,9.57-.04.01-.07.02-.11.02",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.48,180.11c.68-.24,28.01-17.17,28.92-23.94.91-6.77-4.1-7.98-8.65-6.29-4.55,1.69-45.09,25.14-45.09,25.14l24.82,5.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,174.86l23.75,4.86c1.94-1,27.75-17.18,28.61-23.6.34-2.51-.13-4.35-1.39-5.44-1.49-1.3-4.03-1.46-6.8-.44-4.11,1.53-38.27,21.22-44.17,24.62M193.48,180.49s-.04,0-.07,0l-24.82-5.08c-.15-.03-.26-.15-.28-.31-.02-.16.05-.31.18-.38,1.66-.96,40.61-23.49,45.14-25.17,3-1.11,5.79-.9,7.48.56,1.01.88,2.11,2.65,1.64,6.13-.39,2.94-5.34,7.88-14.7,14.67-6.99,5.08-14.04,9.42-14.46,9.57-.04.01-.07.02-.11.02",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.33,127.23c-3.58,11.63-15.35,17.99-26.3,14.19-10.95-3.8-16.93-16.31-13.36-27.94,3.57-11.63,15.35-17.99,26.3-14.19,10.95,3.8,16.93,16.31,13.36,27.94",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.48,103.3c-2.49,0-4.96.62-7.25,1.86-3.82,2.06-6.66,5.58-7.99,9.91-2.75,8.94,1.86,18.58,10.27,21.5,4.07,1.41,8.42,1.06,12.25-1.01,3.82-2.06,6.66-5.58,7.99-9.91,2.75-8.94-1.86-18.58-10.27-21.5-1.64-.57-3.32-.85-5-.85M176.51,138.16c-1.75,0-3.5-.29-5.22-.89-8.78-3.05-13.59-13.11-10.72-22.44,1.39-4.52,4.35-8.19,8.34-10.35,3.99-2.15,8.53-2.52,12.78-1.05,8.78,3.04,13.6,13.11,10.73,22.44-1.39,4.52-4.35,8.19-8.34,10.34-2.39,1.29-4.97,1.94-7.57,1.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,170.86h41.24c1.5,0,2.71-1.29,2.71-2.88v-3.96c0-1.59-1.21-2.88-2.71-2.88h-41.24c-1.5,0-2.71,1.29-2.71,2.88v3.96c0,1.59,1.22,2.88,2.71,2.88",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.41,169.62c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.48,169.62c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.72,169.62c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.08,169.62c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2,169.62c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.27,151.34h-41.24c-1.5,0-2.71,1.29-2.71,2.88v3.96c0,1.59,1.21,2.88,2.71,2.88h41.24c1.5,0,2.71-1.29,2.71-2.88v-3.96c0-1.59-1.22-2.88-2.71-2.88",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.99,159.49c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.87,159.49c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.63,159.49c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27,159.49c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.15,159.49c-.2,0-.35-.17-.35-.38v-6.15c0-.21.16-.37.35-.37s.35.17.35.37v6.15c0,.21-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.75,151.26h41.24c1.5,0,2.71-1.29,2.71-2.88v-3.96c0-1.59-1.21-2.88-2.71-2.88h-41.24c-1.5,0-2.71,1.29-2.71,2.88v3.96c0,1.59,1.22,2.88,2.71,2.88",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.02,150.02c-.2,0-.35-.17-.35-.37v-6.16c0-.21.16-.38.35-.38s.35.17.35.38v6.16c0,.21-.16.37-.35.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,150.02c-.2,0-.35-.17-.35-.37v-6.16c0-.21.16-.38.35-.38s.35.17.35.38v6.16c0,.21-.16.37-.35.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.38,150.02c-.2,0-.35-.17-.35-.37v-6.16c0-.21.16-.38.35-.38s.35.17.35.38v6.16c0,.21-.16.37-.35.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.74,150.02c-.2,0-.35-.17-.35-.37v-6.16c0-.21.16-.38.35-.38s.35.17.35.38v6.16c0,.21-.16.37-.35.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.86,150.02c-.2,0-.35-.17-.35-.37v-6.16c0-.21.16-.38.35-.38s.35.17.35.38v6.16c0,.21-.16.37-.35.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.35,151.82h0l-36.45-.16c-.19,0-.35-.17-.35-.37s.16-.37.35-.37l36.45.16c.2,0,.35.17.35.38s-.16.37-.35.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.99,161.52l-39.49-.05c-.19,0-.35-.17-.35-.38,0-.21.16-.37.35-.37l39.49.05c.2,0,.35.17.35.37s-.16.38-.35.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.42,162.44c1.71-.53,4.33-1.54,6.96-3.63,8.25-6.55,8.71-17.28,14.03-17.62,1.68-.11,2.91.88,3.18,1.09,2.89,2.23,3.06,7.46,1.89,12.1-1.49,5.96-6.71,16.18-6.71,16.18l43.23.5s10.76-7.07,16-8.39c6.74-1.7,8.85,2.56,5.68,7.91-3.18,5.36-28.03,19.73-37.94,22.71-9.9,2.98-67.07,8.53-67.07,8.53-.61-12.22-1.61-25.39-2.22-37.6,7.65-.59,15.31-1.18,22.97-1.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.67,202.19c-.18,0-.33-.15-.35-.34-.02-.21.12-.39.32-.41.57-.06,57.24-5.58,67.01-8.52,9.69-2.91,34.65-17.33,37.74-22.55,1.48-2.5,1.8-4.84.85-6.24-.97-1.44-3.21-1.84-6.15-1.1-3.66.92-9.93,4.45-13.34,6.47-.17.1-.39.04-.48-.14-.1-.18-.04-.41.14-.51,3.44-2.04,9.78-5.6,13.52-6.54,3.28-.83,5.72-.33,6.88,1.4,1.14,1.69.84,4.27-.83,7.08-3.23,5.44-28.1,19.85-38.14,22.87-9.82,2.95-66.56,8.48-67.13,8.54h-.03Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.09,144.46c-.12,0-.24-.07-.31-.19-.37-.69-.84-1.26-1.4-1.69-1.19-.93-2.26-1.06-2.95-1.02-.75.05-1.42.32-2.06.84-.15.13-.37.1-.49-.07-.12-.16-.09-.4.07-.52.75-.61,1.55-.93,2.45-.99.8-.05,2.04.11,3.38,1.15.66.51,1.2,1.16,1.62,1.94.09.18.04.41-.13.51-.06.03-.11.05-.18.05",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.69,205.96s-.04,0-.05,0c-5.55-.91-10.82-2.75-15.67-5.48-4.41-2.49-8.27-5.59-12.5-10.05-14.01-14.79-32.18-44.93-34.2-48.32-.11-.18-.05-.41.11-.52.17-.11.38-.06.49.11,2.02,3.38,20.15,33.46,34.1,48.2,4.18,4.41,7.98,7.47,12.33,9.92,4.78,2.69,9.98,4.51,15.45,5.4.19.03.32.22.29.43-.02.19-.17.32-.35.32",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.39,27.07c.14,1.38.4,2.73.68,4.08.31,1.48.66,2.96,1.12,4.39.84,2.61,2.05,5,3.69,7.02,3.27,4.03,7.8,6.3,12.48,6.59,4.9.31,9.97-1.47,13.86-5.03,3.15-2.88,5.45-7.11,6.04-11.76.88-.58,1.67-1.33,2.36-2.2,1.59-2,2.66-4.52,3.43-7.09.86-2.88,1.29-5.99,1.07-9.04-.4-5.38-2.96-10.61-7.3-12.72-2.09-1.01-4.49-1.24-6.66-.44-2.13.8-4.22,3.02-6.55,1.98-.61-.27-1.18-.64-1.78-.94-.61-.3-1.23-.56-1.87-.77-1.14-.38-2.34-.66-3.52-.48-1.08.17-2.04.77-2.74,1.77-.61.87-1.02,1.89-1.47,2.88-.42.92-.9,1.87-1.67,2.42-.96.69-2.15.68-3.23.77-1.11.1-2.21.3-3.16,1.01-.88.66-1.61,1.63-2.04,2.76-.47,1.22-.56,2.46-.41,3.78.08.71.22,1.47.11,2.18-.11.66-.48,1.11-.85,1.59-1.56,2-1.84,4.65-1.57,7.27",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.69,71.1c1.27-1.7,2.14-3.71,2.51-5.84l4.27-24.48,18.82-.03.18,24.87,5.85-1.36,35.8,74.92L30.25,78.35l5.43-7.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25,78.73c-.08,0-.15-.03-.22-.08-.15-.13-.18-.36-.05-.53l5.43-7.25c1.23-1.65,2.07-3.61,2.44-5.68l4.28-24.48c.03-.18.17-.31.34-.31l18.82-.03c.19,0,.35.17.35.37l.18,24.41,5.43-1.26c.19-.04.38.08.42.29.04.2-.08.4-.27.44l-5.85,1.36c-.1.02-.21,0-.3-.07-.08-.07-.13-.18-.13-.29l-.18-24.5-18.17.03-4.22,24.17c-.38,2.19-1.28,4.27-2.58,6.01l-5.43,7.25c-.07.09-.18.14-.28.14",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.86,71.23c-5.89,0-12.42-2.03-12.76-2.14-.19-.06-.29-.27-.24-.46.05-.2.25-.31.44-.25.11.03,10.42,3.24,16.66,1.67,6.1-1.53,7.17-4.51,7.18-4.54.07-.2.26-.3.45-.23.18.07.28.28.22.47-.04.14-1.16,3.38-7.68,5.02-1.3.33-2.76.46-4.26.46",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.23 71.43 56.16 79.27 61.15 82.16 72.3 113.44 103.27 139.31 93.04 118 64.12 80.89 64.83 76.18 57.23 71.43",
    style: {
      fill: "#e3ebf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.42,84.69s-.04,0-.06,0l-22.88-4.47c-.19-.04-.32-.23-.28-.44.04-.2.22-.34.41-.3l22.53,4.4,1.81-12.42c.02-.12.09-.23.2-.28.11-.05.23-.05.33.02l9.52,5.91,1.59-8.62c.04-.2.22-.34.41-.3.19.04.32.24.28.44l-1.69,9.14c-.02.12-.1.22-.2.27-.1.05-.22.04-.32-.02l-9.5-5.9-1.78,12.26c-.02.1-.07.19-.15.25-.06.05-.13.07-.21.07",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.59,31.14c-1.86.24-3.4,1.93-3.81,3.88-.41,1.94.21,4.03,1.38,5.58,1.18,1.55,2.86,2.59,4.64,3.22.92.33,1.94.59,2.57,1.37.88,1.1.67,2.72.83,4.15.34,3.17,2.71,5.78,5.46,7.07,2.75,1.29,5.84,1.45,8.85,1.4,1.93-.04,3.87-.16,5.72-.74,1.85-.58,3.61-1.64,4.77-3.28,2.08-2.93,1.85-6.96,1.52-10.62-.7-7.8-1.4-15.6-2.1-23.4-5.38,2.58-11.55,3.3-17.34,2.02-1.09-.24-2.42-.48-3.15.41-.49.59-.5,1.47-.48,2.26.05,2.21.1,4.43.15,6.64.03,1.12.04,2.31-.48,3.28-.36.69-1.18,1.35-1.96,1.26-.99-.11-1.16-1.11-1.71-1.87-1.14-1.58-2.88-2.9-4.85-2.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.08,31.49c-.15,0-.3,0-.45.03-1.64.21-3.11,1.72-3.5,3.58-.37,1.74.13,3.7,1.31,5.26,1.03,1.36,2.58,2.43,4.48,3.1.11.04.23.08.35.12.87.29,1.76.6,2.37,1.36.74.92.8,2.12.84,3.28.01.37.03.72.07,1.07.29,2.76,2.35,5.42,5.25,6.78,2.77,1.29,5.95,1.42,8.7,1.36,1.83-.04,3.78-.15,5.63-.72,1.38-.43,3.3-1.33,4.59-3.14,1.95-2.75,1.8-6.47,1.45-10.36l-2.05-22.88c-5.35,2.44-11.4,3.1-17.1,1.84-1.1-.24-2.23-.42-2.82.29-.4.48-.41,1.22-.4,2l.15,6.64c.02,1.06.05,2.38-.52,3.48-.41.78-1.36,1.55-2.31,1.45-.89-.1-1.26-.78-1.58-1.38-.11-.21-.24-.44-.37-.63-.57-.79-2.06-2.53-4.07-2.53M56.55,58.19c-2.59,0-5.46-.23-8.03-1.44-3.17-1.48-5.34-4.31-5.67-7.37-.04-.37-.05-.75-.07-1.12-.04-1.08-.09-2.1-.67-2.82-.49-.61-1.29-.88-2.05-1.14-.12-.04-.24-.08-.36-.13-2.03-.72-3.69-1.87-4.81-3.34-1.32-1.74-1.87-3.95-1.45-5.9.46-2.16,2.18-3.91,4.11-4.16l.04.37-.04-.37c1.83-.24,3.72.78,5.17,2.79.17.23.3.48.43.71.33.61.53.95,1.04,1.01.61.07,1.32-.5,1.62-1.07.48-.92.46-2.07.43-3.09l-.15-6.64c-.02-.9,0-1.83.57-2.52.91-1.1,2.53-.74,3.49-.53,5.72,1.26,11.8.55,17.12-2,.11-.05.23-.04.32.02.1.06.16.17.17.29l2.1,23.4c.35,3.88.51,7.92-1.59,10.88-1.4,1.98-3.47,2.95-4.95,3.41-1.93.6-3.93.72-5.81.75-.32,0-.64,0-.96,0",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.69,40.97c-.09,0-.18-.03-.24-.1-1.44-1.44-2.91-2.27-4.13-2.32-.2,0-.35-.18-.34-.39,0-.21.17-.36.36-.36,1.39.05,3.02.95,4.58,2.52.14.14.15.38.02.53-.07.08-.16.12-.26.12",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,231.27v-7.75c0-2.09,1.6-3.79,3.57-3.79h28.56c1.97,0,3.57,1.7,3.57,3.79v7.75h4.41v-7.75c0-4.67-3.58-8.46-7.97-8.46h-28.56c-4.39,0-7.97,3.8-7.97,8.46v7.75h4.4Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2,234.74h-5.25c-2.27,0-4.12-1.97-4.12-4.38v-.45c0-2.41,1.85-4.38,4.12-4.38h5.25c2.27,0,4.12,1.97,4.12,4.38v.45c0,2.41-1.85,4.38-4.12,4.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.94,225.91c-2.08,0-3.77,1.8-3.77,4v.45c0,2.21,1.69,4.01,3.77,4.01h5.25c2.08,0,3.77-1.8,3.77-4.01v-.45c0-2.21-1.69-4-3.77-4h-5.25ZM113.2,235.11h-5.25c-2.47,0-4.48-2.13-4.48-4.76v-.45c0-2.62,2.01-4.75,4.48-4.75h5.25c2.47,0,4.48,2.13,4.48,4.75v.45c0,2.62-2.01,4.76-4.48,4.76",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.94,234.74h-5.25c-2.27,0-4.12-1.97-4.12-4.38v-.45c0-2.41,1.85-4.38,4.12-4.38h5.25c2.27,0,4.12,1.97,4.12,4.38v.45c0,2.41-1.85,4.38-4.12,4.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.69,225.91c-2.08,0-3.77,1.8-3.77,4v.45c0,2.21,1.69,4.01,3.77,4.01h5.25c2.08,0,3.77-1.8,3.77-4.01v-.45c0-2.21-1.69-4-3.77-4h-5.25ZM152.94,235.11h-5.25c-2.47,0-4.48-2.13-4.48-4.76v-.45c0-2.62,2.01-4.75,4.48-4.75h5.25c2.47,0,4.48,2.13,4.48,4.75v.45c0,2.62-2.01,4.76-4.48,4.76",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.8 229.28 83.77 310.95 194.05 310.95 183.45 229.28 90.8 229.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,310.58h109.49l-10.5-80.93h-92.03l-6.96,80.93ZM194.05,311.33h-110.28c-.1,0-.19-.04-.26-.12-.07-.08-.1-.18-.09-.29l7.02-81.68c.02-.19.17-.34.35-.34h92.65c.17,0,.33.14.35.32l10.6,81.68c.02.11-.02.21-.08.3-.07.08-.16.13-.27.13",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.59,311.33c-.18,0-.33-.14-.35-.33l-5.39-45.04c-.02-.21.11-.39.3-.42.2-.03.37.12.39.32l5.39,45.04c.02.21-.11.39-.3.42-.02,0-.03,0-.05,0",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.99 229.28 70.23 310.95 180.5 310.95 173.48 229.28 78.99 229.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.62,310.58h109.5l-6.96-80.93h-93.86l-8.68,80.93ZM180.5,311.33h-110.28c-.1,0-.2-.05-.26-.13-.07-.08-.1-.19-.09-.29l8.76-81.68c.02-.19.17-.33.35-.33h94.49c.18,0,.33.15.35.34l7.02,81.68c0,.11-.02.21-.09.29-.07.08-.16.12-.26.12",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,267.94h-95.75c-.2,0-.35-.17-.35-.37s.16-.38.35-.38h95.37l-1.18-17.54c-.01-.21.13-.38.33-.4.19,0,.37.14.38.35l1.21,17.95c0,.1-.02.21-.09.28-.07.08-.16.12-.26.12",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.74,
    y: 265.91,
    width: 17.71,
    height: 8.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.1,274.25h17.01v-7.95h-17.01v7.95ZM134.46,274.99h-17.71c-.2,0-.35-.17-.35-.37v-8.7c0-.21.16-.37.35-.37h17.71c.19,0,.35.17.35.37v8.7c0,.21-.16.37-.35.37",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.24,43.65h59.04c1.86,0,3.37-1.6,3.37-3.57V3.92c0-1.97-1.51-3.57-3.37-3.57h-41.77c-1.86,0-3.37,1.6-3.37,3.57v27.59l-13.9,12.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.16,43.3h58.13c1.68,0,3.04-1.45,3.04-3.23V3.92c0-1.78-1.36-3.23-3.04-3.23h-41.77c-1.67,0-3.04,1.45-3.04,3.23v27.59c0,.1-.04.2-.12.27l-13.2,11.52ZM152.28,44h-59.04c-.14,0-.26-.09-.31-.23-.05-.14,0-.29.1-.38l13.78-12.03V3.92c0-2.16,1.66-3.92,3.69-3.92h41.77c2.04,0,3.69,1.76,3.69,3.92v36.15c0,2.16-1.66,3.92-3.69,3.92",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.29,12.26c-3.54,0-6.42,3.27-6.42,7.3,0,.04,0,.1-.02.18-.01-.09-.03-.15-.03-.18,0-4.03-2.87-7.3-6.41-7.3s-6.42,3.27-6.42,7.3c0,10.44,12.83,14.16,12.83,14.16,0,0,.01-.01.03-.04.02.02.02.04.02.04,0,0,12.83-3.72,12.83-14.16,0-4.03-2.87-7.3-6.41-7.3",
    style: {
      fill: "#e3ebf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.83,102.86c-.18,0-.33-.15-.33-.35v-42.43h-10.56c-.18,0-.33-.15-.33-.35s.15-.35.33-.35h10.89c.18,0,.33.16.33.35v42.77c0,.19-.15.35-.33.35",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.87,60.09h-70.18c-.18,0-.33-.15-.33-.35s.15-.35.33-.35h70.18c.18,0,.33.16.33.35s-.15.35-.33.35",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.87,51.25h-70.18c-.18,0-.33-.15-.33-.35s.15-.35.33-.35h70.18c.18,0,.33.16.33.35s-.15.35-.33.35",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.87,42.41h-89.42c-.18,0-.33-.15-.33-.35s.15-.35.33-.35h89.42c.18,0,.33.16.33.35s-.15.35-.33.35",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.46,59.74c0-1.76-1.35-3.19-3-3.19s-3,1.43-3,3.19,1.35,3.19,3,3.19,3-1.43,3-3.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.45,56.9c-1.47,0-2.68,1.27-2.68,2.84s1.2,2.84,2.68,2.84,2.68-1.27,2.68-2.84-1.2-2.84-2.68-2.84M203.45,63.28c-1.84,0-3.33-1.59-3.33-3.54s1.49-3.54,3.33-3.54,3.33,1.59,3.33,3.54-1.49,3.54-3.33,3.54",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.22,51.24c0-2.06-1.57-3.73-3.51-3.73s-3.51,1.67-3.51,3.73,1.57,3.73,3.51,3.73,3.51-1.67,3.51-3.73",
    style: {
      fill: "#5770b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.32,42.09c0-1.76-1.35-3.19-3-3.19s-3.01,1.43-3.01,3.19,1.35,3.19,3.01,3.19,3-1.43,3-3.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.31,39.25c-1.47,0-2.68,1.27-2.68,2.84s1.2,2.84,2.68,2.84,2.68-1.27,2.68-2.84-1.2-2.84-2.68-2.84M245.31,45.62c-1.84,0-3.33-1.59-3.33-3.54s1.49-3.54,3.33-3.54,3.33,1.59,3.33,3.54-1.49,3.54-3.33,3.54",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(165.48 128.27) rotate(10)",
    style: {
      fill: "#fff",
      fontFamily: "Titillium-SemiboldUpright, Titillium",
      fontSize: "29.32px",
      fontWeight: 600
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione04Img01);
export default __webpack_public_path__ + "static/media/sezione-04-img-01.dfcda1a3db2ad757eda3691327f9ef1e.svg";
export { ForwardRef as ReactComponent };